
import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FilterComponent } from '../filter/filter.component';
import { Router, RouterLink } from '@angular/router';
import { faMars, faVenus, faCheck, faClose, faTrash,faCircleRadiation,faCircle as faCircleRegular } from '@fortawesome/free-solid-svg-icons';
import {
  debounceTime,
  Subject,

} from 'rxjs';
import { MatFormField } from '@angular/material/form-field';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { SnackbarService } from '../services/snackbar.service';
import { Subscription } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'app-member-list',
  standalone: true,
  imports: [CommonModule, FilterComponent, RouterLink, MatFormField, FormsModule,FontAwesomeModule],
  templateUrl: './member-list.component.html',
  styleUrl: './member-list.component.css',
})
export class MemberListComponent {
  members: any[] = [];
  page: any = 1;
  limit: any = 8;
  isLoading: boolean = false;
  formval: any = {};
  totalpages: any = 0;
  hasmoredata: boolean = true;
  searchQuery: string = '';
  searchSubject: Subject<string> = new Subject<string>();
  @ViewChild('filterOverlay') filterOverlay!: FilterComponent;
  @Input() login_popup: boolean = false;
  back: any;
  search: any;
  profileComplete!: boolean;
   famale = faMars;
    fafemale = faVenus;
    fatrans=faCircleRegular;


  constructor(public api: ApiServicesService, private router: Router, private userdetails: UserDetailsService, private snackbarService: SnackbarService) { }

  private userDetailsSubscription!: Subscription;

  ngOnInit(): void {
    this.back = this.api.frontendAssetsUrl + 'ban.jpg';
    this.search = this.api.frontendAssetsUrl + 'download.svg';
    this.loadMembers();
    this.searchSubject.pipe(debounceTime(1000)).subscribe((query: string) => {
      this.page = 1;
      this.hasmoredata = true;
      this.members = [];
      this.formval.search = query;
      this.loadMembers();
    });



    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.api.decryptData(userdata);
      if (decryptedData && decryptedData.user) {

        this.profileComplete=decryptedData.user.profileCompleteness==1?true:false;
      }
    }
  }


  ngOnDestroy(): void {
    if (this.userDetailsSubscription) {
      this.userDetailsSubscription.unsubscribe();
    }
  }


  view_member(username: any) {
    if (this.profileComplete == true) {
      this.router.navigate(['/member-profile', username, 'Profile']);
    } else {
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Complete Your profile before using this feature',
          className: 'failed',
        }
      );
    }
  }

  onSearchChange(): void {
    this.searchSubject.next(this.searchQuery);
  }

  loadMembers(): void {
    if (this.isLoading || !this.hasmoredata) {
      return;
    }
    this.isLoading = true;
    this.api.loadMembers(this.page, this.formval?.search, this.formval?.gender, this.formval?.country, this.formval?.state, this.formval?.city, this.formval?.ageFrom, this.formval?.ageTo, this.formval?.seekingFor,this.limit).subscribe({
      next: (data: any) => {
        if(data.status===200){
        this.totalpages = data.totalPages || 0;
        if (data) {
          this.members = [...this.members, ...data.user_data];
        }
        }
        else {
          this.hasmoredata = false;
        }
        this.isLoading = false;

        
        if(data.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: data.message,
              className: 'failed',
            }
          );
        }
      
      },
      error: (error) => {
        this.isLoading = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: error.error.message,
            className: 'failed',
          }
        );
      },
    });
  }

  setmemberdata(formval: any) {
    this.page = 1;
    this.hasmoredata = true;
    this.members = [];
    this.formval = formval;
    this.loadMembers();
  }

  @HostListener('window:scroll', ["$event"])
  onScroll(event: Event): void {
    const target = event.target as Document;
    const scrollTop = target.scrollingElement?.scrollTop || 0;
    const innerHeight = window.innerHeight;
    const scrollHeight = target.scrollingElement?.scrollHeight || 0;
    if (
      innerHeight + scrollTop >= scrollHeight - 100 && !this.isLoading && this.hasmoredata && (this.page < this.totalpages)) {
      this.page++;
      this.loadMembers();
    }
  }
  openFilter() {
    this.filterOverlay.open();
  }
}
